module.exports = __webpack_public_path__ + "static/media/intro-new.463473ce.png";